import React, { useState, useEffect } from "react";

const head = {
  "heading": "Alumni Network Features",
  "description": "Explore the powerful features of our Alumni Network designed to connect and support alumni across the globe.",
}

const Database = [
  {
    "label": "Fresh Passouts",
    "name": "Career Guidance and Support",
    "description": "Access alumni job boards. Connect with mentors. Explore career resources. Discover success stories.",
    "options": [
      "Access alumni job boards",
      "Connect with mentors",
      "Explore career resources",
      "Discover success stories"
    ],
    "icon_class": "far fa-lightbulb",
    "image_url": "/assets/mentorship.png",
    "image_prompt": "What kind of simple 2D vector image would you like for career guidance and support? (e.g., lightbulb)"
  },
  {
    "label": "Graduates with 10+ Years of Experience",
    "name": "Mentorship Opportunities",
    "description": "Mentor current students and young alumni. Share expertise and career paths. Stay connected and contribute to development.",
    "options": [
      "Mentor current students and young alumni",
      "Share expertise and career paths",
      "Stay connected and contribute to development"
    ],
    "icon_class": "fas fa-user-friends",
    "image_url": "./assets/mentrop.webp",
    "image_prompt": "What kind of simple 2D vector image would you like for mentorship opportunities? (e.g., people)"
  },
  {
    "label": "Alumni in Different Countries",
    "name": "Global Networking",
    "description": "Connect globally with alumni from your school. Expand professional network worldwide. Find potential partners in global markets.",
    "options": [
      "Connect globally with alumni from your school",
      "Expand professional network worldwide",
      "Find potential partners in global markets"
    ],
    "icon_class": "fas fa-globe",
    "image_url": "./assets/global _etworking.png",
    "image_prompt": "What kind of simple 2D vector image would you like for global networking? (e.g., globe)"
  }

];
const FeaturesComp = () => {
  const [feature, setFeature] = useState("Fresh Passouts");
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (feature !== "") {
      let data = Database?.find((dt) => dt?.label == feature);
      setSelected(data);
    }
  }, [feature]);

  console.log("selected", selected);

  return (
    <div className="features_comp">
      <div className="container">
        <div className="comp_header">
          <h1>{head?.heading}</h1>
          <p>
            {head?.description}
          </p>
        </div>
        <div className="feature_tabs">
          {Database?.map((data, idx) => (
            <div
              className={feature == data?.label ? "active_tab" : ""}
              onClick={() => setFeature(data?.label)}
            >
              <i class={data?.icon_class}></i>
              <h5>{data?.label}</h5>
            </div>
          ))}
        </div>
        <div className="comp_data">
          <div className="first">
            {/* <img src={`/assets/${feature}.jpeg`} alt="" /> */}
            <img src={selected?.image_url} alt="" />
          </div>
          <div className="second">
            <h3>{selected?.name}</h3>
            <p>{selected?.description}</p>
            <div className="points">
              {selected?.options?.map((dt) => (
                <p>
                  <i class="fa-solid fa-check"></i> {dt}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesComp;
